module.exports = __webpack_public_path__ + "static/Recurso-22aace4cb2a8348ecfd3906f76f37c76.png";